export default "__VITE_ASSET__ca9636ab__"